import DashboardTypes from './dashboard.types';

export const dashboardStart = (data: any) => ({
	type: DashboardTypes.DASHBOARD_START,
	payload: data,
});

export const dashboardSuccess = (data: any) => ({
	type: DashboardTypes.DASHBOARD_SUCCESS,
	payload: data,
});

export const dashboardFailure = (error: unknown) => ({
	type: DashboardTypes.DASHBOARD_FAILURE,
	payload: error,
});

export const dashboardResponseChanged = () => ({
	type: DashboardTypes.DASHBOARD_RESPONSE_CHANGED,
});

export const dashboardResponseRestStart = () => ({
	type: DashboardTypes.DASHBOARD_RESPONSE_REST_START,
});

export const getPendingLeaveRequestsStart = (data: any) => ({
	type: DashboardTypes.GET_PENDING_LEAVE_REQUESTS_START,
	payload: data,
});

export const getPendingLeaveRequestsSuccess = (data: any) => ({
	type: DashboardTypes.GET_PENDING_LEAVE_REQUESTS_SUCCESS,
	payload: data,
});

export const getPendingLeaveRequestsFailure = (error: unknown) => ({
	type: DashboardTypes.GET_PENDING_LEAVE_REQUESTS_FAILURE,
	payload: error,
});

export const getPendingLeaveRequestsResponseChanged = () => ({
	type: DashboardTypes.GET_PENDING_LEAVE_REQUESTS_RESPONSE_CHANGED,
});

export const getPendingLeaveRequestsResponseRestStart = () => ({
	type: DashboardTypes.GET_PENDING_LEAVE_REQUESTS_RESPONSE_REST_START,
});

// Enhanced Dashboard Actions
export const dashboardEnhancedStart = (data: any) => ({
	type: DashboardTypes.DASHBOARD_ENHANCED_START,
	payload: data,
});

export const dashboardEnhancedSuccess = (data: any) => ({
	type: DashboardTypes.DASHBOARD_ENHANCED_SUCCESS,
	payload: data,
});

export const dashboardEnhancedFailure = (error: unknown) => ({
	type: DashboardTypes.DASHBOARD_ENHANCED_FAILURE,
	payload: error,
});

export const dashboardEnhancedResponseChanged = () => ({
	type: DashboardTypes.DASHBOARD_ENHANCED_RESPONSE_CHANGED,
});

export const dashboardEnhancedResponseRestStart = () => ({
	type: DashboardTypes.DASHBOARD_ENHANCED_RESPONSE_REST_START,
});

// Enhanced Employee List Actions
export const employeeListEnhancedStart = (data: any) => ({
	type: DashboardTypes.EMPLOYEE_LIST_ENHANCED_START,
	payload: data,
});

export const employeeListEnhancedSuccess = (data: any) => ({
	type: DashboardTypes.EMPLOYEE_LIST_ENHANCED_SUCCESS,
	payload: data,
});

export const employeeListEnhancedFailure = (error: unknown) => ({
	type: DashboardTypes.EMPLOYEE_LIST_ENHANCED_FAILURE,
	payload: error,
});

export const employeeListEnhancedResponseChanged = () => ({
	type: DashboardTypes.EMPLOYEE_LIST_ENHANCED_RESPONSE_CHANGED,
});

export const employeeListEnhancedResponseRestStart = () => ({
	type: DashboardTypes.EMPLOYEE_LIST_ENHANCED_RESPONSE_REST_START,
});
